// extracted by mini-css-extract-plugin
export default {"box":"TextChart_box__HyehJ","content":"TextChart_content__rAw8n","padding":"TextChart_padding__rtDcf","warning":"TextChart_warning__1C-j4"};